<label class="tt-toggleswitch">
  <input type="checkbox" [checked]="_checked()" [disabled]="disabled" (change)="onModelChange($event)" />
  <span class="tt-toggleswitch_slider"></span>
</label>
<span class="tt-toggleswitch_label">{{ label }}</span>
